import { render, staticRenderFns } from "./starbrand.vue?vue&type=template&id=7da42ce4&scoped=true"
import script from "./starbrand.vue?vue&type=script&lang=js"
export * from "./starbrand.vue?vue&type=script&lang=js"
import style0 from "./starbrand.vue?vue&type=style&index=0&id=7da42ce4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da42ce4",
  null
  
)

export default component.exports